import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Clamp a string to a maximum length, appending '...' if truncated
export function clampString(str: string, maxLength: number) {
  if (typeof str !== 'string') return '';
  if (str.trimEnd().length <= maxLength) return str;
  return str.slice(0, maxLength).trimEnd().concat('...');
}

// Determine interval and date format based on range
export const getXAxisConfig = (days: number) => {
  const totalTicks = Math.max(5, Math.min(10, Math.floor(days / 7)));
  const interval = Math.max(0, Math.ceil(days / totalTicks));

  const format = days >= 365 ? 'MMM yyyy' : 'MMM d';

  return { interval, format };
};
